import http from './http';

export async function getCatalog() {
  const { data } = await http.get('/api/catalog');
  return data;
}

export async function getCategory(topSlug) {
  const { data } = await http.get(`/api/catalog/${topSlug}`);
  return data;
}

export async function getSubcategory(topSlug, subSlug) {
  const { data } = await http.get(`/api/catalog/${topSlug}/${subSlug}`);
  return data;
}
